export default function guest({ next, store }) {
  let isLoggedIn = store.getters['auth/getLoggedIn']
  if (isLoggedIn) {
    return next('/')
  }
  return next()
}
